import { useState } from 'react';
import { toast } from 'react-toastify';

const useProductComparison = () => {
  const [selectedProducts, setSelectedProducts] = useState(() => {
    // Load data from localStorage when initializing the state
    if (typeof localStorage !== 'undefined') {
      const storedData = localStorage.getItem('comparisonProducts');
      return storedData ? JSON.parse(storedData) : [];
    } else {
      return [];
    }
  });

  // Add product to the selectedProducts array
  const addToComparison = (productId) => {
    if (selectedProducts.length > 3) {
      toast.dark('حداکثر تعداد محصولات قابل مقایسه 4 عدد می باشد');
      return;
    }
    const updatedProducts = [...selectedProducts, productId];
    setSelectedProducts(updatedProducts);
    localStorage.setItem('comparisonProducts', JSON.stringify(updatedProducts));
  };

  // Remove a product from selectedProducts by its ID
  const removeFromComparison = (productId) => {
    const updatedProducts = selectedProducts.filter(
      (product) => product !== productId
    );
    setSelectedProducts(updatedProducts);

    localStorage.setItem('comparisonProducts', JSON.stringify(updatedProducts));
  };

  return {
    selectedProducts,
    addToComparison,
    removeFromComparison,
  };
};

export default useProductComparison;
